import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function initCrossSell() {
  const blocks = document.querySelectorAll(".cross-sell-block:not(.js-initialized)");
  if (!blocks.length) return;

  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const mm = gsap.matchMedia();

  blocks.forEach((block) => {
    block.classList.add("js-initialized");

    mm.add({
      // Desktop
      isDesktop: "(min-width: 992px)",
      // Mobile
      isMobile: "(max-width: 991px)",
      // Reduced motion
      reduce: "(prefers-reduced-motion: reduce)"
    }, (context) => {
      let { isDesktop, reduce } = context.conditions;
      const WRAP_SELECTOR = ".cross-sell-block__item .wrap";
      const items = block.querySelectorAll(WRAP_SELECTOR);

      if (reduce) {
        gsap.set(items, { y: 0, autoAlpha: 1 });
        return;
      }

      // Initial state
      gsap.set(items, { y: isDesktop ? 60 : 40, autoAlpha: 0 });

      block.querySelectorAll(".row").forEach((row) => {
        const rowItems = row.querySelectorAll(WRAP_SELECTOR);
        if (!rowItems.length) return;

        gsap.timeline({
          scrollTrigger: {
            trigger: row,
            start: isDesktop ? "top 75%" : "top 85%",
            toggleActions: "play none none none",
            invalidateOnRefresh: true,
          },
          defaults: {
            duration: isDesktop ? 0.6 : 0.65,
            ease: "back.out(1.8)"
          },
        })
          .to(rowItems, {
            y: 0,
            autoAlpha: 1,
            stagger: 0.12,
          });
      });
    });
  });

  // Ensure refresh on load
  window.addEventListener("load", () => ScrollTrigger.refresh());
}
